import { DOMHelper } from "../Helpers/DOMHelper.js";

export class ShiftBmwModule {

    constructor(shiftDatalayer) {        
        this.shiftDatalayer = shiftDatalayer;
        this.initiatedForms = {};// to remember and not double fire it
        this.enabled = false;
        this.chatProviderName ='pixelmotion';
    }

    /**
     * 
     * @returns boolean true if it's enabled 
     */
    init() {        
        this.enabled = 'sdb' in window;
        return this.enabled;
    }

    formInitiationEvent ({formType}) {
        console.info("PmDrsShift: formInitiation");        
        sdbDataLayer = {
            formType: formType,
            displayType: 'modal',
            events: 'formInitiation',
            formVehicle: this.shiftDatalayer.getVehicleDetails()
        };                
        sdb('send');
        return sdbDataLayer;
    }

    formFieldInteractionEvent ({formType, formFieldName}) {
        console.info("PmDrsShift: formFieldInteraction");
        sdbDataLayer = {
            formType: formType,
            displayType: 'modal',
            events: 'formFieldInteraction',
            formFieldName: formFieldName,
            formVehicle: this.shiftDatalayer.getVehicleDetails()
        };

        sdb('send');
        return sdbDataLayer;
    }

    formShownEvent({formType}) {
        console.info("PmDrsShift: formShown");

        var sdbDataLayerFormShown = {
            formType: formType,
            events: 'formShown',
            formVehicle: this.shiftDatalayer.getVehicleDetails()
        };

        sdb('dataLayer', sdbDataLayerFormShown);//trying to get formShown event displayed in SD Analytics tab
        sdb('send');
        return sdbDataLayerFormShown;
    }

    formSubmissionEvent({leadId, formType, prefContact}) {
        console.info("PmDrsShift: formSubmission");

        sdbDataLayer = {
            leadId: leadId,
            formType: formType,
            leadType: 'lead', //Indicates if the form is a lead, a handraiser (notintended to be sent to the dealer), or both
            // prefContact: prefContact,
            events: 'formSubmission',
            formVehicle: this.shiftDatalayer.getVehicleDetails()
        };

        sdb('send');
        return sdbDataLayer;
    }

    chatImpressionEvent({}) {
        return;
        console.info("PmDrsShift: chatImpression");

        sdbDataLayer = { 
            chatProfitCenter: 'sales',
            chatType: 'chat',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            events: 'chatImpression'
        }

        sdb('send');
        return sdbDataLayer;
    }

    chatClickEvent({}) {
        return;
        console.info("PmDrsShift: chatClick");

        sdbDataLayer = { 
            chatProfitCenter: 'sales',
            chatType: 'chat',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            events: 'chatClick'
        }

        sdb('send');
        return sdbDataLayer;
    }

    chatMessageEvent({chatMessageContent}) {
        return;
        console.info("PmDrsShift: chatMessage");

        sdbDataLayer = { 
            chatProfitCenter: 'sales',
            chatType: 'chat',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            chatMessageType: 'user',
            chatMessageContent: chatMessageContent,
            events: 'chatUserMessage'
        }

        sdb('send');
        return sdbDataLayer;
    }

    chatLeadEvent({chatLeadId}) {
        return;
        console.info("PmDrsShift: chatLead");

        sdbDataLayer = { 
            chatProfitCenter: 'sales',
            chatType: 'chat',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            chatLeadId: chatLeadId,            
            events: 'chatLead'
        }

        sdb('send');
        return sdbDataLayer;
    }

    chatDrHandoffEvent({}) {//probably won't be used
        return;
        console.info("PmDrsShift: chatDrHandoff");

        sdbDataLayer = { 
            chatProfitCenter: 'sales',
            chatType: 'DR',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            events: 'chatDrHandoff'
        }

        sdb('send');
        return sdbDataLayer;
    }

    chatClosedEvent({}) {
        return;
        console.info("PmDrsShift: chatClosed");

        sdbDataLayer = { 
            chatProfitCenter: 'sales',
            chatType: 'chat',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            events: 'chatClosed'
        }

        sdb('send');
        return sdbDataLayer;
    }
}